import {takeLatest, put, call} from 'redux-saga/effects'
import Logger from '../../../helpers/logger'
import {AxiosServices} from '../../../network/AxiosService';
import {ApiServices} from '../../../network/ApiServices';
import {PROJECTS} from "../../constants/projects";


function* fetchProjectsMain() {
    try {
        const result = yield call(
            AxiosServices.get,
            ApiServices.GET_ALL_PROJECTS,
            ''
        );

        yield put({
            type: PROJECTS.FETCH_PROJECTS_PAGE.SUCCESS,
            result:  result.data
        })

    } catch(err) {
        console.log(err);
        Logger(err)
        yield put({
            type: PROJECTS.FETCH_PROJECTS_PAGE.FAILURE
        })
    }
}

function* fetchProjectsByCategory(actions) {
    try {
        const result = yield call(
            AxiosServices.get,
            ApiServices.GET_PROJECT_BY_CATEGORY,
            actions.params
        );


        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY.SUCCESS,
            result:  result.data
        })

    } catch(err) {
        console.log(err);
        Logger(err)
        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY.FAILURE
        })
    }
}

function* fetchProjectsByCategoryOngoing(actions) {
    try {
        const result = yield call(
            AxiosServices.get,
            ApiServices.GET_PROJECT_BY_CATEGORY,
            actions.params
        );


        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY_ONGOING.SUCCESS,
            result:  result.data
        })

    } catch(err) {
        console.log(err);
        Logger(err)
        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY_ONGOING.FAILURE
        })
    }
}

function* fetchProjectsByCategoryCompleted(actions) {
    try {
        const result = yield call(
            AxiosServices.get,
            ApiServices.GET_PROJECT_BY_CATEGORY,
            actions.params
        );


        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY_COMPLETED.SUCCESS,
            result:  result.data
        })

    } catch(err) {
        console.log(err);
        Logger(err)
        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY_COMPLETED.FAILURE
        })
    }
}

function* fetchProjectsByCategoryUpcoming(actions) {
    try {
        const result = yield call(
            AxiosServices.get,
            ApiServices.GET_PROJECT_BY_CATEGORY,
            actions.params
        );


        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY_UPCOMING.SUCCESS,
            result:  result.data
        })

    } catch(err) {
        console.log(err);
        Logger(err)
        yield put({
            type: PROJECTS.FETCH_PROJECTS_BY_CATEGORY_UPCOMING.FAILURE
        })
    }
}

function* fetchProjectsDetail(actions) {
    try {
        const result = yield call(
            AxiosServices.get,
            ApiServices.GET_PROJECT_DETAIL,
            actions.params
        );


        yield put({
            type: PROJECTS.FETCH_PROJECTS_DETAIL_PAGE.SUCCESS,
            result:  result.data
        })

    } catch(err) {
        console.log(err);
        Logger(err)
        yield put({
            type: PROJECTS.FETCH_PROJECTS_DETAIL_PAGE.FAILURE
        })
    }
}

export default function* projectSagas() {
    yield takeLatest(PROJECTS.FETCH_PROJECTS_PAGE.MAIN, fetchProjectsMain);
    yield takeLatest(PROJECTS.FETCH_PROJECTS_BY_CATEGORY.MAIN, fetchProjectsByCategory);
    yield takeLatest(PROJECTS.FETCH_PROJECTS_BY_CATEGORY_ONGOING.MAIN, fetchProjectsByCategoryOngoing);
    yield takeLatest(PROJECTS.FETCH_PROJECTS_BY_CATEGORY_COMPLETED.MAIN, fetchProjectsByCategoryCompleted);
    yield takeLatest(PROJECTS.FETCH_PROJECTS_BY_CATEGORY_UPCOMING.MAIN, fetchProjectsByCategoryUpcoming);
    yield takeLatest(PROJECTS.FETCH_PROJECTS_DETAIL_PAGE.MAIN, fetchProjectsDetail);

}